import { WebSocketConversationTransferStatusInboundMessage } from 'middleware/webSocket';

/** Creates an id in order to use in notifications */
export function getConversationTransferRequestNotificationId(
  type: WebSocketConversationTransferStatusInboundMessage['params']['type'],
  csid: number,
): string {
  return `conversation_transfer_${type}_request_${csid}`;
}
